export const TO_MANUAL_ADDRESS_VERIFICATION = '@@od/store/sellerFlow/toManualAddressVerification';
export const CANCEL_MANUAL_ADDRESS_VERIFICATION =
  '@@od/store/sellerFlow/cancelManualAddressVerification';

export const ERROR_ANSWER = '@@od/store/sellerFlow/errorAnswer';
export const DO_CURRENT_PAGE_LATER = '@@od/store/sellerFlow/doCurrentPageLater';
export const ERROR_PAGE = '@@od/store/sellerFlow/errorPage';

export const TRACK_EVENT = '@@od/store/sellerFlow/trackEvent';
export const HANDLE_EXCEPTION = '@@od/store/sellerFlow/handleException';

export const RECEIVE_HUMAN = '@@od/store/sellerFlow/receiveHuman';
export const SEND_PASSWORD_SETUP_EMAIL = `@@od/store/sellerFlow/sendPasswordSetUpEmail`;
